import { useReducer } from "react"
import { Languages } from "../../types/LanguagesI"
import { loggedUserPages, PageI, PageType } from "../../types/PageI"
import PageContext from "../context/PageContext"
import PageReducer from "../reducer/PageReducer"

const PageState = (props: any) => {
    
    let type = PageType.entrance

    let active_page = ""

    if ("xf_active_page" in sessionStorage) {
        active_page = sessionStorage.getItem("xf_active_page") || ""
    }
    // console.log(active_page);
    
    // for a json parser 
    if (active_page == "") {
        active_page = "{}"    
    }

    // console.log(active_page);

    type = JSON.parse(active_page  || PageType.entrance) as PageType
    
    // type = PageType.entrance

    let url = new URL(window.location.href)    
    active_page = ""
    // the URL active page has priority 
    if (url.searchParams.has("xf_page")) {
        active_page = url.searchParams.get('xf_page') || "";

        // set session storage xf_page
        sessionStorage.setItem('xf_active_page', JSON.stringify(active_page));
    }


    type = active_page as PageType || type


    if (!("xf_active_user" in sessionStorage) && loggedUserPages.includes(type)) {
        // console.log("xf_active_user is not set".toUpperCase());
        // console.log(loggedUserPages.includes(type));
        
        type = PageType.entrance
        sessionStorage.setItem('xf_active_page', JSON.stringify(PageType.entrance));
        
        let url_search_params = new URLSearchParams(window.location.search) 
        url_search_params.set('xf_page', PageType.entrance)
        let id = Date.now().toString();
        
        window.history.pushState(
            {
                "id": id,
                "xf_page": PageType.entrance
            }, 
            '', 
            "?" + url_search_params.toString()
        );

    }
    const lang = (document.getElementById('xplore_react_reservations') as HTMLElement).getAttribute('lang') as Languages

    // console.log(type, lang);
    
    const init_state_page_context:PageI = {
        header_loaded: false,
        type: type,
        props: {},
        settings: {
            language: lang
        },
        notifications: [],
        popup: null
    }
    const [page, setPage] = useReducer(PageReducer, init_state_page_context)

    return (
        <PageContext.Provider value={{page, dispatchPage: setPage}}>
            {props.children}
        </PageContext.Provider>
    )
}   

export default PageState